import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function CountdownSection() {
  return <section className="py-12 px-4 bg-cream-light border-b border-cream-dark" data-id="element-59">
      <div className="max-w-3xl mx-auto text-center" data-id="element-60">
        <h3 className="text-xl md:text-2xl font-bold text-carbon mb-6 flex items-center justify-center gap-2" data-id="element-61">
          ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
        </h3>

        <div className="mb-6" data-id="element-62">
          <CountdownTimer data-id="element-63" />
        </div>

        <p className="text-red-600 font-medium mb-8 bg-red-50 inline-block px-4 py-2 rounded-full text-sm" data-id="element-64">
          ⚠️ Después sube $10.000 ARS. No vuelve.
        </p>

        <div className="bg-white p-6 rounded-2xl shadow-sm border border-cream-dark" data-id="element-65">
          <div className="flex justify-between items-end mb-2" data-id="element-66">
            <span className="text-sm font-bold text-carbon" data-id="element-67">
              🔴 Cupos al precio de lanzamiento — Quedan pocos
            </span>
            <span className="text-sm font-bold text-brand-green" data-id="element-68">68%</span>
          </div>
          <div className="w-full bg-cream-dark rounded-full h-3 overflow-hidden" data-id="element-69">
            <div className="bg-brand-green h-3 rounded-full" style={{
            width: '68%'
          }} data-id="element-70"></div>
          </div>
          <p className="text-xs text-carbon-lighter mt-2 text-left" data-id="element-71">
            68% de los cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </div>
    </section>;
}